// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy-number-title p[data-v-655f3b71]{margin-bottom:10px}`, "",{"version":3,"sources":["webpack://./src/web/components/client/notifications/modals/components/simpleModal.vue"],"names":[],"mappings":"AAEE,qCACE,kBAAA","sourcesContent":["\n.buy-number-title {\n  p {\n    margin-bottom: 10px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
